var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isVisible)?_c('div',{staticClass:"behavior-editor-div"},[_c('movable-text-box-input-method-editor',{attrs:{"source":_vm.source,"disabled":_vm.disabled}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }